import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ActionPayload {
  visible?: boolean;
  message?: string;
  type?: string;
}

const initialState: ActionPayload = {
  message: "",
  type: "",
  visible: false,
};

const toasterSlice = createSlice({
  name: "toaster",
  initialState,
  reducers: {
    setToastMessage: (state, action: PayloadAction<any>) => {
      state.visible = action.payload.visible;
      state.message = action.payload.message;
      state.type = action.payload.type;
    },
  },
});

export const { setToastMessage } = toasterSlice.actions;
export default toasterSlice.reducer;
